"use client";
import { BuilderBlockProps, SortingObject } from "@/types";
import { FC, useContext } from "react";
import { IndexCardsContext } from "./IndexContextBlock";
import { Select } from "@/components/Select";
import { Dropdown } from "@/types/General/Dropdown";
import { getDataAutomationGroup } from "@/helpers";

type SortButtonBlockProps = {
  options: (SortingObject & {
    label: string;
    ariaLabel?: string;
    dld?: string;
    dlt?: string;
  })[];
  placeholder: string;
} & BuilderBlockProps;
export const SortButtonBlock: FC<SortButtonBlockProps> = (props) => {
  const options = props.options?.map((option) => ({
    label: option?.label,
    value: option?.label,
    ariaLabel: option?.ariaLabel,
    dld: option?.dld,
    dlt: option?.dlt,
  }));
  const { onSort, activeSortDescriptor } = useContext(IndexCardsContext);

  const matchingIndex = activeSortDescriptor
    ? props.options?.findIndex((option) =>
        activeSortDescriptor.type !== "custom"
          ? "field" in option &&
            "order" in option &&
            option.field === activeSortDescriptor.field &&
            option.order === activeSortDescriptor.order
          : option.type === "custom" &&
            option.callback === activeSortDescriptor.callback,
      )
    : 0;

  const sortOption =
    (!activeSortDescriptor && props.placeholder) || !options?.[matchingIndex]
      ? { label: props.placeholder, value: "" }
      : options[matchingIndex];

  return (
    <div {...props.attributes}>
      <Select
        variant="rectangular"
        formControlContainerClassName="bg-background"
        options={options}
        value={sortOption}
        {...getDataAutomationGroup("dropdown")}
        onChange={(value: Dropdown) => {
          const index = options.findIndex(
            ({ value: optionValue }) => value.value === optionValue,
          );

          const option = props.options?.[index];
          onSort(option);
        }}
      />
    </div>
  );
};
